// Default shipping constants
// Used when no shipping rate is selected or for initial estimates
export const DEFAULT_SHIPPING_ESTIMATE = 15.0; // $15.00
export const DEFAULT_SHIPPING_ESTIMATE_CENTS = 1500; // 1500 cents (for API calls)
